import React, { useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import ResumeUpload from "./components/ResumeUpload";
import ResumeReview from "./components/ResumeReview";

function App() {
  const [reviewData, setReviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        <img
          src="/HireDash-removebg.png"
          alt="HireDash Logo"
          className="logo"
        />
        <h1 className="logo-title">Resume Roaster</h1>
        <p className="tagline">
          Let our AI Malaysian recruiter roast your resume! 🔥 <br />
          It isn’t here to sugarcoat but to call out your main character energy
          and delulu moments
        </p>
      </header>
      <main>
        {!reviewData && (
          <ResumeUpload
            setReviewData={setReviewData}
            setIsLoading={setIsLoading}
          />
        )}

        {reviewData && !isLoading && (
          <ResumeReview
            reviewData={reviewData}
            onReset={() => setReviewData(null)}
          />
        )}
      </main>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <h2>Roasting your resume...</h2>
            <div className="loader"></div>
            <p>This might take a minute</p>
            <img
              src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExcmx0bWo3MWVpNzJ0OGZ3Z2F2ZnFxdG9lYjlkMGkzeDVwNWZpMmxiNSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/QMHoU66sBXqqLqYvGO/giphy.gif"
              alt="Roasting gif"
              className="loading-gif"
            />
          </div>
        </div>
      )}

      <footer>
        <p>
          © {new Date().getFullYear()} HireDash |{" "}
          <span className="footer-vibe">A fun Gen-Z project</span>
        </p>
      </footer>

      {/* Vercel Analytics */}
      <Analytics />
    </div>
  );
}

export default App;
